import React from 'react';
import { useStore } from '@thd-nucleus/experience-context';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { Room } from './Room';

export const RoomContainer = ({ ...props }) => {
  const { isCustomerIdentified = false } = useThdCustomer();
  const store = useStore();
  const { storeZip, isLocalized } = store;
  const roomDefaultVariables = {
    zipCode: storeZip,
    isBrandPricingPolicyCompliant: isLocalized ? isCustomerIdentified : false
  };

  return (
    <QueryProvider
      cacheKey="room-page"
      defaultVariables={roomDefaultVariables}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Room {...props} />
    </QueryProvider>
  );
};

RoomContainer.propTypes = {};

RoomContainer.defaultProps = {};

RoomContainer.displayName = 'RoomContainer';
